import { SectionSubtitle } from '../..'

type Props = {
  showError?: boolean
  message?: string
  height?: number
  showMandatoryError?: boolean
}

export const FieldValidation = ({
  message,
  height = 20,
  showError = false,
  showMandatoryError = false,
}: Props) => {
  return (
    <div style={{ height, marginBottom: 5 }}>
      {showError && (
        <SectionSubtitle fontWeight={400} fontSize={12}>
          {message}
        </SectionSubtitle>
      )}
      {showMandatoryError && (
        <SectionSubtitle
          fontWeight={400}
          fontSize={12}
          children="Campo Obligatorio"
        />
      )}
    </div>
  )
}
